import { isEmpty } from 'lodash';

import {
    DEVICE_ADD,
    DEVICE_REORDER,
    DEVICE_REMOVE,
    DEVICE_TOGGLE_SELECT,
    DEVICE_UPDATE,
    DEVICES_TOGGLE,
    FETCH_DEVICES,
    FETCH_DEVICE_OBJECTS,
    SET_DEVICE,
    SET_DEVICES_LOADING,
    SET_DEVICE_PROCESS_IDS,
    SET_DEVICE_TOTAL
} from '../actions/actionTypes';

import { patchItem, removeItem } from '../helpers/collections';

const initialState = {
    devices:         [],
    devicesLoading:  false,
    deviceObjects:   [],
    order:           'asc',
    orderBy:         'name',
    processIds:      [],
    selectedDevice:  null,
    selectedDevices: [],
    totalDevices:    0,
    updatedAt:       null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case DEVICE_ADD:
            return {
                ...state,
                devices: [...state.devices, action.payload]
            };
        case DEVICE_REORDER:
            return {
                ...state,
                ...action.payload
            };
        case DEVICE_REMOVE:
            return {
                ...state,
                devices: removeItem(state.devices, action.payload.id)
            };
        case DEVICE_TOGGLE_SELECT:
            return {
                ...state,
                devices: patchItem(
                    state.devices,
                    action.payload.id,
                    ({ isSelected }) => ({
                        isSelected: !isSelected
                    })
                )
            };
        case DEVICES_TOGGLE:
            return {
                ...state,
                selectedDevices: [...action.payload]
            };
        case DEVICE_UPDATE:
            return {
                ...state,
                devices: patchItem(
                    state.devices,
                    action.payload.id,
                    action.payload.patch
                )
            };
        case FETCH_DEVICES:
            return {
                ...state,
                devices:   [...action.payload],
                updatedAt: new Date()
            };
        case FETCH_DEVICE_OBJECTS:
            return {
                ...state,
                deviceObjects: [...action.payload]
            };
        case SET_DEVICE: {
            const selectedDevice = isEmpty(action.payload) ? null : {...action.payload};

            return {
                ...state,
                selectedDevice
            };
        }
        case SET_DEVICES_LOADING: {
            return {
                ...state,
                devicesLoading: action.payload
            };
        }
        case SET_DEVICE_PROCESS_IDS: {
            return {
                ...state,
                processIds: [...action.payload]
            };
        }
        case SET_DEVICE_TOTAL: {
            return {
                ...state,
                totalDevices: action.payload
            };
        }
        default:
            return state;
    }
};
